/**
 * RAP — Retail Approvals.
 *
 * Bill 2026-04-24 mandate: Microsoft Teams Approvals are surfaced and actioned
 * INSIDE this app — badged in the chrome, listed/managed inside the panel,
 * leveraging all M365 Approvals API functionality possible.
 *
 * Tabs:
 *   1. Pending  — live cards via Microsoft Graph; in-card Approve/Reject.
 *   2. History  — last-30-day decisions.
 *   3. Config   — Manager+ — reason templates, auto-approve thresholds, SLA,
 *                  CD waiver matrix, archive-reason gates.
 *
 * The previous "config + reporting only" copy and the "open Microsoft Teams
 * → Approvals" punt are GONE. PCB does not push approvers out to Teams.
 */

import { Route, Routes, Navigate } from 'react-router';
import { ApprovalsLanding } from './ApprovalsLanding';

export default function RAP(): JSX.Element {
  return (
    <Routes>
      <Route index element={<ApprovalsLanding />} />
      {/* Legacy /rap/config and /rap/history routes redirect to the new tabbed
          landing — old links from elsewhere in the app keep working. */}
      <Route path="config" element={<Navigate to="/rap" replace />} />
      <Route path="history" element={<Navigate to="/rap" replace />} />
    </Routes>
  );
}
